import { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Box,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
  Switch,
} from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import "../../../Style/dialogstyle.scss";
// import useGetEnrollmentByClassAndStudent from "../../../Hooks/useGetEnrollmentByClassAndStudent";
//Import from project
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { BiMinusCircle } from "react-icons/bi";
import { SelectStudent } from "../../Include/DynamicSelect/DynamicSelect";
import { SelectmultiScheduleByClass } from "../../Include/DynamicSelect/DynamicSelect";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";
import {
  CREATE_STUDENT_ENROLLMENT,
  // UPDATE_STUDENT_ENROLLMENT,
} from "../../../Schema/Class";

export default function AssignStudentToClassForm({
  open,
  editData,
  classId,
  tableData,
  setRefetch,
  handleClose,
  defaultTotalHour,
  dialogTitle,
}) {
  // Change Language
  const { setAlert, t } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selecteSchedule, setSelecteSchedule] = useState([]);
  const [isNewStudent, setIsNewStudent] = useState(
    editData?.isNewStudent ? editData?.isNewStudent : false,
  );

  const [createStudentEnrollment] = useMutation(CREATE_STUDENT_ENROLLMENT, {
    onCompleted: ({ createStudentEnrollment }) => {
      setLoading(false);
      if (createStudentEnrollment?.isSuccess === true) {
        setAlert(true, "success", createStudentEnrollment?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createStudentEnrollment?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageEn: message, messageKh: message });
    },
  });

  // const [updateStudentEnrollment] = useMutation(UPDATE_STUDENT_ENROLLMENT, {
  //   onCompleted: ({ updateStudentEnrollment }) => {
  //     // console.log("updateStudentEnrollment :", updateStudentEnrollment);
  //     setLoading(false);
  //     if (updateStudentEnrollment?.isSuccess === true) {
  //       setAlert(true, "success", updateStudentEnrollment?.message);
  //       handleClose();
  //       resetForm();
  //       setRefetch();
  //     } else {
  //       setAlert(true, "error", updateStudentEnrollment?.message);
  //     }
  //   },
  //   onError: ({ message }) => {
  //     setLoading(false);
  //     setAlert(true, "error", { messageEn: message, messageKh: message });
  //   },
  // });

  //
  const ValidationSchema = Yup.object().shape({
    remark: Yup.string(),
    totalHour: Yup.number().moreThan(0).required(t("required")),
    studentId: Yup.object().shape({
      id:
        dialogTitle === "Create"
          ? Yup.string().required(t("required"))
          : Yup.string(),
      title: Yup.string(),
    }),
    scheduleId: Yup.string().required(t("required")),
    payAs: Yup.string().required(t("required")),
    startSchoolDate:
      dialogTitle === "Create"
        ? Yup.string().required(t("required"))
        : Yup.string(),
    // endHourDate: Yup.string().required(t("required")),
    endHourDate: Yup.date()
      .required(t("required"))
      .test(
        "is-after",
        t("End date must be after start date"),
        function (value) {
          const { startSchoolDate } = this.parent;
          return value && startSchoolDate
            ? moment(value).isAfter(moment(startSchoolDate))
            : true;
        },
      ),
  });

  const formik = useFormik({
    initialValues: {
      remark: "",
      payAs: "month",
      scheduleId: "",
      studentId: { id: "", title: "" },
      totalHour: defaultTotalHour ?? 0,
      startSchoolDate: moment(),
      endHourDate: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values) => {
      // setLoading(true);
      // console.log("sdfsdf::", values, selecteSchedule)
      //
      // if (dialogTitle === "Update") {
      //   updateStudentEnrollment({
      //     variables: {
      //       id: enrollmentData?._id,
      //       input: {
      //         startSchoolDate: moment(values?.startSchoolDate).format(
      //           "YYYY-MM-DD"
      //         ),
      //         classId: classId,
      //         totalHour: parseFloat(values?.totalHour),
      //         // scheduleId: selecteSchedule?.map((e) => e?.id),
      //         // remark: values?.remark,
      //       },
      //     },
      //   });
      // } else {
      createStudentEnrollment({
        variables: {
          input: {
            // ...values,
            startSchoolDate: moment(values?.startSchoolDate).format(
              "YYYY-MM-DD",
            ),
            endHourDate: moment(values?.endHourDate).format("YYYY-MM-DD"),
            classId: classId,
            studentId: values?.studentId?.id,
            payAs: values?.payAs,
            totalHour: parseFloat(values?.totalHour),
            scheduleId: selecteSchedule?.map((e) => e?.id),
            isNewStudent: isNewStudent,
            remark: values?.remark,
          },
        },
      });
      // }
    },
  });

  // console.log("details in class 022....", dialogTitle);

  const {
    values,
    errors,
    touched,
    resetForm,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  useEffect(() => {
    resetForm();
    setFieldValue("totalHour", defaultTotalHour);
    setFieldValue("remark", "");
  }, [open]);

  useEffect(() => {
    if (selecteSchedule?.length > 0) {
      setFieldValue("scheduleId", "scheduleId");
    } else {
      setFieldValue("scheduleId", "");
    }
  }, [selecteSchedule]);

  // useEffect(() => {
  //   if (enrollmentData && dialogTitle === "Update") {
  //     setFieldValue("studentId", {
  //       id: editData?._id,
  //       title: `${enrollmentData?.studentId?.familyName} ${enrollmentData?.studentId?.studentName}`,
  //     });
  //     setFieldValue("remark", enrollmentData?.remark);
  //     setFieldValue("totalHour", enrollmentData?.totalHour);
  //     setFieldValue("payAs", editData?.payAs || "month");
  //     setFieldValue("startSchoolDate", enrollmentData?.startSchoolDate);
  //   }
  //   if (enrollmentData?.scheduleId?.length > 0) {
  //     setSelecteSchedule(
  //       enrollmentData?.scheduleId?.map((data) => {
  //         return {
  //           id: data?._id,
  //           title: data?.day + " " + data?.startTime + "-" + data?.endTime,
  //         };
  //       })
  //     );
  //   }
  // }, [open, enrollmentData]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="flex-end"
          justifyContent="center"
        >
          <Typography className="dialog-title">
            {t("modal_title_add_student")}
          </Typography>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={7}>
                <SelectStudent
                  studentType={"direct"}
                  disabled={dialogTitle === "Update"}
                  data={tableData?.map((e) => ({ studentId: { id: e?._id } }))}
                  value={
                    values?.studentId?.id
                      ? values?.studentId
                      : { id: "", title: "" }
                  }
                  onChange={(val) =>
                    setFieldValue("studentId", val || { id: "", title: "" })
                  }
                />
                {!!errors.studentId?.id && touched.studentId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.studentId?.id}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={5}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_pay_as")}
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={values?.payAs}
                    onChange={(e) => setFieldValue("payAs", e.target.value)}
                  >
                    <MenuItem value="month">Month</MenuItem>
                    <MenuItem value="course">Course</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_study_start_date")}
                </Typography>
                <SelectDatePicker
                  disabled={dialogTitle === "Update"}
                  value={values?.startSchoolDate}
                  onChange={(val) =>
                    setFieldValue("startSchoolDate", val || "")
                  }
                />
                {!!errors.startSchoolDate && touched.startSchoolDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startSchoolDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_end_school_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.endHourDate}
                  onChange={(val) => setFieldValue("endHourDate", val || "")}
                />
                {!!errors.endHourDate && touched.endHourDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endHourDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_total_hour")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  type="number"
                  size="small"
                  className="text-field"
                  placeholder={t("thead_total_hour")}
                  InputProps={{
                    endAdornment: (
                      <Typography className={t("class-name-field-title")}>
                        {t("thead_hour")}
                      </Typography>
                    ),
                  }}
                  {...getFieldProps("totalHour")}
                  error={Boolean(touched.totalHour && errors.totalHour)}
                  helperText={touched.totalHour && errors.totalHour}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_new_student")}
                </Typography>
                <Switch
                  checked={isNewStudent}
                  onChange={(e) => setIsNewStudent(e.target.checked)}
                  slotProps={{ input: { "aria-label": "controlled" } }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_schedule")}
                </Typography>
                <SelectmultiScheduleByClass
                  classId={classId}
                  value={selecteSchedule}
                  onChange={(data, val) => setSelecteSchedule(val)}
                />
                {!!errors.scheduleId && touched.scheduleId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.scheduleId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  disabled={dialogTitle === "Update"}
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
